import React, { useEffect, useState } from "react";
import {
  getFormatDatesJst,
  getFormattedDateJst,
  getFormattedTimeJst,
} from "../../../utils/dateformatter";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Button,
  Container,
  Dropdown,
  DropdownMenu,
  DropdownToggle,
  FormGroup,
  Modal,
} from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faGear } from "@fortawesome/free-solid-svg-icons";
import { faHome } from "@fortawesome/free-regular-svg-icons";
import { locationInfo } from "../../../services/locationApi";
import { tempInfo } from "../../../services/tempApi";
import { weatherCode } from "../WeatherCode";

const DashboardNav = ({
  selectedValue,
  setSelectedValue,
  setLocationData,
  locationData,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const user = sessionStorage.getItem("username");
  const isLoggedIn = !!sessionStorage.getItem("session_key");
  const isEquipmentPage = location.pathname === "/equipment";

  const [currentDate, setCurrentDate] = useState(getFormattedDateJst());
  const [currentTime, setCurrentTime] = useState(getFormattedTimeJst());
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [showLogout, setShowLogout] = useState(false);
  const [tempData, setTempData] = useState({});
  const [weatherDisplay, setWeatherDisplay] = useState("0-0");
  const [tempSelectedValue, setTempSelectedValue] = useState(selectedValue);

  const [isTempLoading, setIsTempLoading] = useState(false);
  const [isAreaLoading, setIsAreaLoading] = useState(false);

  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);
  const toggleLogout = () => {
    setShowLogout((prev) => !prev);
  };

  const systemId = Number(sessionStorage.getItem("system_id")) || 2;

  const options =
    systemId === 3
      ? [{ value: "microgrid", label: "マイクログリッド" }]
      : [
          { value: "yakuba", label: "釧路町役場" },
          { value: "microgrid", label: "マイクログリッド" },
        ];

  const goToSettings = () => {
    navigate("/equipment");
  };

  const goToHome = () => {
    navigate("/dashboard");
  };

  const applySelection = () => {
    setSelectedValue(tempSelectedValue);
  };

  const handleCheckboxChange = (value) => {
    setTempSelectedValue((prev) => {
      let updated;
      if (prev.includes(value)) {
        updated = prev.filter((item) => item !== value);
      } else {
        updated = [...prev, value];
      }
      if (!updated.includes("microgrid") && !updated.includes("yakuba")) {
        updated.push(systemId === 3 ? "microgrid" : "yakuba");
      }
      return updated;
    });
  };

  const fetchAreaInfo = async () => {
    setIsTempLoading(true);
    try {
      const response = await tempInfo({
        system_id: Number(sessionStorage.getItem("system_id")) || 2,
      });
      if (response?.data) {
        setTempData(response.data);

        if (response.data.weather_code) {
          const codeNum = Number(response.data.weather_code);
          setWeatherDisplay(weatherCode(codeNum));
        }
      }
    } catch (error) {
      console.error("Error fetching area info:", error);
    } finally {
      setIsTempLoading(false);
    }
  };

  const fetchLocationInfo = async () => {
    setIsAreaLoading(true);
    try {
      const response = await locationInfo({
        system_id: Number(sessionStorage.getItem("system_id")) || 2,
        request_type: "info",
      });
      setLocationData(response?.data?.info || {});
    } catch (error) {
      console.error("Error fetching location info:", error);
    } finally {
      setIsAreaLoading(false);
    }
  };

  useEffect(() => {
    if (isLoggedIn) {
      fetchAreaInfo();
      fetchLocationInfo();
    }
  }, [isLoggedIn]);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentDate(getFormattedDateJst());
      setCurrentTime(getFormattedTimeJst());
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <Container fluid className="px-5">
        <div className="d-flex flex-wrap  gap-xxl-5 mx-auto my-2 align-items-center ">
          <div className="d-flex flex-wrap  gap-xl-2 gap-xxl-4 align-items-center">
            <div className="d-flex flex-column align-items-start gap-2 cursor-pointer">
              <img
                src="./logo_FD.png"
                alt="logo"
                className="logoSize"
                onClick={(e) => {
                  navigate("/location-select");
                }}
              />

              <span>
                <img src="./User Profile 01.png" alt="logo" />
                アカウント:
                <span className="userFont" onClick={toggleLogout}>
                  {user}
                </span>
              </span>
            </div>

            <div className="d-flex flex-column align-items-start   ">
              <span className="fs-6 fs- d-flex">
                <img className="timeIcon" src="./Calendar.png" />
                <span className="fontColor">
                  {getFormatDatesJst(currentDate)}
                </span>
              </span>
              <span className="fs-6 d-flex">
                <img className="timeIcon" src="./Clock.png" />
                <span className="fontColor"> {currentTime}</span>
              </span>
            </div>

            <div className="d-flex align-items-end">
              <img src="./Location.png" alt="location" />

              <span
                style={{
                  fontSize: "16px",
                  whiteSpace: "nowrap",
                  marginLeft: "4px",
                }}
              >
                {locationData?.address}
              </span>
            </div>

            <div className="d-flex justify-content-between  gap-xl-3 align-items-end">
              <div className="d-flex flex-column align-items-center gap-0  ">
                <span className="fs-6">
                  <img className="tempIcon" src={`/${weatherDisplay}.png`} />
                </span>
                <span className="tempFont ">天気予報</span>
              </div>

              <div className="d-flex flex-column align-items-start    ">
                <div className="temp-display">
                  <span className="temperature">
                    {tempData?.average_temperature}
                    <sup className="unit">°C</sup>
                  </span>
                </div>
                <span className="tempFont pt-1">平均気温</span>
              </div>
            </div>
            {!isEquipmentPage && (
              <>
                <div>
                  <FormGroup className="mt-3">
                    <Dropdown
                      isOpen={dropdownOpen}
                      toggle={toggleDropdown}
                      className="menu-show"
                    >
                      <DropdownToggle className="dropDown d-flex justify-content-between align-items-center">
                        {selectedValue?.length > 0
                          ? options
                              .filter((opt) =>
                                tempSelectedValue?.includes(opt.value),
                              )
                              .map((opt) => opt.label)
                              .join(" + ")
                          : "選択してください"}
                        <FontAwesomeIcon icon={faChevronDown} size="xs" />
                      </DropdownToggle>
                      <DropdownMenu className="w-100">
                        {options.map((option) => (
                          <div
                            key={option.value}
                            style={{ padding: "4px 12px" }}
                          >
                            <input
                              type="checkbox"
                              checked={tempSelectedValue?.includes(
                                option.value,
                              )}
                              onChange={() =>
                                handleCheckboxChange(option.value)
                              }
                              style={{ marginRight: "6px" }}
                            />
                            {option.label}
                          </div>
                        ))}
                      </DropdownMenu>
                    </Dropdown>
                  </FormGroup>
                </div>

                <Button
                  className="displayButton btn-sm"
                  onClick={applySelection}
                >
                  表示更新
                </Button>
              </>
            )}
          </div>

          {isEquipmentPage ? (
            <Button className="btn-sm ms-auto setting" onClick={goToHome}>
              <FontAwesomeIcon icon={faHome} />
              <span className="ps-2 fw-bold">ホーム</span>
            </Button>
          ) : (
            <Button
              className="btn-sm ms-auto setting"
              onClick={goToSettings}
              disabled={systemId === 3}
            >
              <FontAwesomeIcon icon={faGear} />
              <span className="ps-2 fw-bold">設定</span>
            </Button>
          )}
        </div>

        {showLogout && (
          <Modal
            isOpen={showLogout}
            toggle={toggleLogout}
            className="logoutModal-content"
          >
            <div>
              <span className="d-flex justify-content-center align-items-center gap-2 py-2">
                <img className="userImage" src="./username.png" alt="logo" />
                <span className="userLogout">{user}</span>
              </span>
              <div className="hr mt-0 mb-0" />
              <div className="d-flex justify-content-end pe-3 py-2 ">
                <Button
                  className="btn-sm logoutBtn"
                  onClick={() => {
                    sessionStorage.clear();
                    navigate("/");
                  }}
                >
                  <img className="pe-2" src="./logout.png" />
                  ログアウト
                </Button>
              </div>
            </div>
          </Modal>
        )}
      </Container>
    </>
  );
};

export default DashboardNav;
